import React, { useEffect, useState, useRef } from "react";
import { isLimitExceededLocal } from "../../../redux/actions/note.action";
import { ShowAlert } from "../../../common/alert";
import { useLabels } from "../../../context/label/labelProvider";

export default function Timewatch({ stopWatch, setGetSecond, initialTime, noteId = "", setInitialTime = () => { }, stopBtnRef = null, isVimProvider = false }) {
   const timerIntervalRef = useRef(null);
   const [time, setTime] = useState("00:00");
   const startTimeRef = useRef(null);
   const elapsedTimeRef = useRef(0);
   const { labels } = useLabels()

   useEffect(() => {
      if (stopWatch.start && !startTimeRef.current) {
         start();
      }
      if (stopWatch.play && startTimeRef.current) {
         start(true);
      }
      if (stopWatch.stop) {
         clearInterval(timerIntervalRef.current);
         startTimeRef.current = null;
         elapsedTimeRef.current = 0;
         setTime("00:00");
         localStorage.removeItem("stopWatch");
      }

      return () => {
         clearInterval(timerIntervalRef.current);
      };
   }, [stopWatch]);

   useEffect(() => {
      if (initialTime) {
         const parsedTime = parseTime(initialTime);
         if (parsedTime) {
            elapsedTimeRef.current = parsedTime;
            print(timeToString(parsedTime));
            setInitialTime("");
         }
      }
   }, [initialTime]);

   const parseTime = (timeString) => {
      const [minutes, seconds] = timeString.split(":").map(Number);
      return minutes * 60000 + seconds * 1000;
   };

   const timeToString = (time) => {
      let totalMinutes = Math.floor(time / 60000);
      let ss = Math.floor((time % 60000) / 1000);
      let mm = totalMinutes;
      let formattedMM = mm.toString().padStart(2, "0");
      let formattedSS = ss.toString().padStart(2, "0");
      setGetSecond({ seconds: formattedSS, minutes: formattedMM });
      return `${formattedMM}:${formattedSS}`;
   };

   const print = (txt) => {
      if (isLimitExceededLocal(txt) && !isVimProvider) {
         stopBtnRef?.current?.click(true);
         ShowAlert(labels.recordingTimeLimitExceeded, "error");
      }
      setTime(txt);
      const noteIds = localStorage.getItem("noteIdCurrent");
      if (noteIds || noteId) {
         let note = noteIds || noteId;
         localStorage.setItem(note, txt);
      }
   };

   function start(val = false) {
      if (!val) {
         startTimeRef.current = Date.now() - elapsedTimeRef.current;
      } else {
         startTimeRef.current = Date.now() - elapsedTimeRef.current;
      }
      timerIntervalRef.current = setInterval(function printTime() {
         elapsedTimeRef.current = Date.now() - startTimeRef.current;
         print(timeToString(elapsedTimeRef.current));
         let stop = localStorage.getItem("stopWatch");
         if (stop && stop === "true") {
            clearInterval(timerIntervalRef.current);
            localStorage.removeItem("stopWatch");
         }
      }, 1000);
   }

   return (
      <div>
         <span id="display">{time}</span>
      </div>
   );
}